<mat-checkbox class="checkbox"
    *ngIf="view === 'data' || view === 'fill'"
    [checked]="value"
    (change)="updateValue($event)"
    [disabled]="view === 'data'"
>{{ label }}</mat-checkbox>
